import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../../../shared/services/date.service';

@Pipe({
  name: 'searchDisplay',
  standalone: true,
})
export class SearchDisplayPipe implements PipeTransform {
  private dateService = inject(DateService);

  transform(value: any): string {
    const parts: string[] = [];

    if (value.firstName && value.lastName) {
      parts.push(`${value.firstName} ${value.lastName}`);
    }

    if (value.dateOfBirth) {
      const formattedDate = this.dateService.formatToDateString(value.dateOfBirth);
      parts.push(`DOB: ${formattedDate}`);
    }

    if (value.memberId) {
      parts.push(`Member ID: ${value.memberId}`);
    }

    if (value.policyNumber) {
      parts.push(`Policy Number: ${value.policyNumber}`);
    }

    if (value.externalId) {
      parts.push(`Alternative ID: ${value.externalId}`)
    }

    return parts.join(' | ');
  }
}
